const themes = {
    default: {
        title: "Default",
        themeH: 215,
        themeS: "15%",
        appBackground: "#a1e0ff",
        background: "white",
        darkBackground: "#144C80",
        header: "#001529",
        icons: "#1890ff",
        font: "#1890ff",
        font2: "white",
        btnInfo: "#1890ff",
        btnDanger: "rgb(237, 85, 59)",
        btnSuccess: "#1dd17a",
        btnWarn: "#F6D55C"
    },
    xmas: {
        title: "Christmas",
        themeH: 142,
        themeS: "42%",
        appBackground: "#76e7a9ff",
        background: "white",
        darkBackground: "#A13127",
        header: "#1dd17a",
        icons: "#ED5E51", 
        font: "rgb(237, 85, 59)",
        font2: "white",
        btnInfo: "#1890ff",
        btnDanger: "rgb(237, 85, 59)",
        btnSuccess: "#1dd17a",
        btnWarn: "#F6D55C"
    },
    ocanada: {
        title: "O Canada",
        themeH: 0,
        themeS: "0%",
        appBackground: "white",
        background: "white",
        darkBackground: "#A13127",
        header: "#D80621",
        icons: "#ED5E51", 
        font: "rgb(237, 85, 59)",
        font2: "white",
        btnInfo: "#1890ff",
        btnDanger: "rgb(237, 85, 59)",
        btnSuccess: "#1dd17a",
        btnWarn: "#F6D55C"
    },
    halloween: {
        title: "Halloween",
        themeH: 28,
        themeS: "28%",
        appBackground: "#2b2b2bff",
        background: "white",
        darkBackground: "#3a3a3aff",
        header: "#e98e17ff",
        icons: "#000000ff", 
        font: "#edbc51ff",
        font2: "white",
        btnInfo: "#1890ff",
        btnDanger: "rgb(237, 85, 59)",
        btnSuccess: "#1dd17a",
        btnWarn: "#F6D55C"
    },
    mint: {
        title: "Mint Chocolate Chip",
        themeH: 173,
        themeS: "29%",
        appBackground: "#94E0CC",
        background: "white", //settings drawer
        darkBackground: "#20617A",
        header: "#6999AC",
        icons: "#AD6170", 
        font: "#AD6170",
        font2: "white",
        btnInfo: "#1890ff",
        btnDanger: "#E46A5E",
        btnSuccess: "#1dd17a",
        btnWarn: "#F6D55C"
    },
    coastal: {
        title: "Coastal",
        themeH: 198,
        themeS: "34%",
        appBackground: "#BFE9F7",
        background: "white",
        darkBackground: "#1E5A7A",
        header: "#0F3F5A",
        icons: "#1C84B5",
        font: "#0F3F5A",
        font2: "white",
        btnInfo: "#1C84B5",
        btnDanger: "#D65D4A",
        btnSuccess: "#2D9E72",
        btnWarn: "#F2B64A"
    },
    terracotta: {
        title: "Terracotta",
        themeH: 18,
        themeS: "42%",
        appBackground: "#F2D2C3",
        background: "white",
        darkBackground: "#7D3E2D",
        header: "#5E2C20",
        icons: "#C56A45",
        font: "#7A3B2B",
        font2: "white",
        btnInfo: "#3F89C8",
        btnDanger: "#C6453B",
        btnSuccess: "#3F8A55",
        btnWarn: "#E6A63E"
    },
    alpine: {
        title: "Alpine",
        themeH: 158,
        themeS: "24%",
        appBackground: "#CFE9DF",
        background: "white",
        darkBackground: "#275646",
        header: "#1E473A",
        icons: "#2F7A63",
        font: "#1E473A",
        font2: "white",
        btnInfo: "#2E7FBE",
        btnDanger: "#C74E4A",
        btnSuccess: "#2F9E68",
        btnWarn: "#D9A93A"
    },
    slate: {
        title: "Slate",
        themeH: 212,
        themeS: "18%",
        appBackground: "#D7E0EA",
        background: "white",
        darkBackground: "#2E3F52",
        header: "#1F2C3A",
        icons: "#4C6F94",
        font: "#2A3E53",
        font2: "white",
        btnInfo: "#3A78BF",
        btnDanger: "#C8514B",
        btnSuccess: "#2F8F69",
        btnWarn: "#D8A33D"
    },
    sunrise: {
        title: "Sunrise",
        themeH: 38,
        themeS: "52%",
        appBackground: "#FCE6B8",
        background: "white",
        darkBackground: "#8A5D16",
        header: "#6A4712",
        icons: "#C7861E",
        font: "#6A4712",
        font2: "white",
        btnInfo: "#347CC3",
        btnDanger: "#CC4D3E",
        btnSuccess: "#3D9759",
        btnWarn: "#E0A127"
    },
    birthdaycake: {
        title: "Birthday Cake",
        themeH: 352,
        themeS: "58%",
        appBackground: "#FFF5F7",
        background: "#FFFFFF",
        darkBackground: "#B32645",
        header: "#D93A54",
        icons: "#34B7E7",
        font: "#B32645",
        font2: "white",
        btnInfo: "#34B7E7",
        btnDanger: "#E13E5D",
        btnSuccess: "#59D885",
        btnWarn: "#FFE38A"
    }
};

export const allThemes = themes;

export const appColours = (theme = "default") => {
    return themes[theme] || themes.default;
}